/* @ngInject */
export default function routing($routeProvider, $locationProvider, $httpProvider, APP_ROUTES) {
    $routeProvider.when(APP_ROUTES.HOME.path, {
        templateUrl: require('./../components/home/home.component.html'),
        controller: 'HomeComponent',
        reload: false,
        title: 'Welcome to Component Edge',
        name: APP_ROUTES.HOME.name,
        reloadOnSearch: false
    }).when(APP_ROUTES.BROWSING.path, {
        templateUrl: require('./../components/browse/browse.component.html'),
        controller: 'BrowseComponent',
        reload: false,
        title: 'Browsing Component Edge',
        name: APP_ROUTES.BROWSING.name,
        reloadOnSearch: false
    }).when(APP_ROUTES.PART_LISTING.path, {
        templateUrl: require('./../components/technology/technology.component.html'),
        controller: 'TechnologyComponent',
        reload: false,
        title: 'Browsing Technology',
        name: APP_ROUTES.PART_LISTING.name,
        reloadOnSearch: false
    }).when(APP_ROUTES.PART_DETAIL.path, {
        templateUrl: require('./../components/distributor/distributor.component.html'),
        controller: 'DistributorComponent',
        reload: false,
        title: 'Distributor Information',
        name: APP_ROUTES.PART_DETAIL.name,
        reloadOnSearch: false
    }).when(APP_ROUTES.EXT_SLEUTH.path, {
        template: ' ',
        controller: 'ExternalSearchExecutionController',
        reload: false,
        title: '',
        name: APP_ROUTES.EXT_SLEUTH.name,
        reloadOnSearch: false
    }).otherwise({
        redirectTo: '/'
    });

    $locationProvider.hashPrefix('');

    //IE fix to avoid caching XHR requests
    $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';

    // Provide an interceptor for errors.
    $httpProvider.interceptors.push('ErrorInterceptor');
}
